module.exports = __webpack_public_path__ + "img/image18.66691d79.png";